import React, { useRef, useEffect, useState } from 'react';
import { YoutubeOutlined, CodeSandboxOutlined, HomeOutlined } from '@ant-design/icons';

import { Layout, Menu, theme } from 'antd';

const { Header, Content, Footer, Sider } = Layout;
const items = [
  {
    key: 'cgen',
    icon: <CodeSandboxOutlined />,
    label: 'Cgen 代码沙箱AI助理',
    checked: true
  },
  {
    key: 'vgen',
    icon: <YoutubeOutlined />,
    label: 'Vgen 视频学习AI助理',
  }
];
export default () => {
  const [currentNav, setCurrentNav] = useState('cgen');
  const [vgenUrl, setVgenUrl] = useState(null);

  useEffect(() => {
    if (currentNav === 'cgen') {
      console.log('cgen');
    } else if (currentNav === 'vgen') {
      console.log('vgen')
      if (vgenUrl === null){
        setVgenUrl(process.env.REACT_APP_VGEN_URL)
      }
    }
  }, [currentNav]);

  const menuClick = e => {
    setCurrentNav(e.key)
  };
  return (
    <div style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
      <div><HomeOutlined /><b>云燕工具广场</b></div>
      <Layout hasSider style={{ flex: 1}}>
        <Sider style={{ width: 220, background: '#fff'}}
               width={220}
        >
          <Menu
            onClick={menuClick}
            style={{ width: 220 }}
            defaultSelectedKeys={['cgen']}
            mode="inline"
            items={items}
          />
        </Sider>
        <Layout>
          <Content>

            <div style={{ height: '100%',display: currentNav==='cgen' ? 'block' : 'none' }}>
              <p>cgen</p>
            </div>
            <div style={{ height: '100%',display: currentNav==='vgen' ? 'block' : 'none' }}>
              <iframe src={vgenUrl}
                    style={{ width: '100%', height: '100%', border: 0, borderRadius: 4, overflow: 'hidden' }}
                    title="Cgen AI Assistant"
                    allow="accelerometer; ambient-light-sensor; camera; encrypted-media; geolocation; gyroscope; hid; microphone; midi; payment;"/>
            </div>
          </Content>
        </Layout>
      </Layout>
    </div>

  );
};
